import defaultSettings from '@/settings'

const title = defaultSettings.title || '大中小企业融通创新服务平台'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${title} - ${pageTitle}`
  }
  return `${title}`
}
